import Swiper from "swiper";
import { Navigation } from "swiper/modules";

jQuery(($) => {
	/****************** TABS / SELECT ******************/

	$(".tabs-select").on("change", function () {
		const selectedValue = $(this).val();
		const selectClass = $(this).attr("class").split(" ")[0];
		switchSelect(selectedValue, selectClass);
	});

	function switchSelect(selectedValue, selectClass) {
		$(`.${selectClass}.tab-block`).addClass("hidden");
		$(`.${selectClass}.tab-block`).removeClass("active");
		$(`#${selectedValue}.${selectClass}`).removeClass("hidden");
		$(`#${selectedValue}.${selectClass}`).addClass("active");
		$(`.${selectClass}.tabs-select`).val(`${selectedValue}`);
	}

	/****************** TABS ******************/

	$(".tabs").on("click", ".tab", function () {
		switchTab($(this));
	});

	function switchTab($tab) {
		const parentClassGlobal = $tab
			.parent()
			.parent()
			.parent()
			.parent()
			.attr("class");

		const parentClass = parentClassGlobal.split(" ")[3];

		const selectedTabId = $tab.attr("id");
		const tabs = selectedTabId.split("-");

		$(`.${parentClass} .tab`).removeClass("active");
		$(`.${parentClass} #tab-${tabs[1]} `).addClass("active");

		const newUrl = `/offers/#${tabs[1]}`;
		window.history.pushState({ path: newUrl }, "", newUrl);

		$(`.${parentClass}.tab-block`).removeClass("active");
		$(`.${parentClass}.tab-block`).addClass("hidden");

		$("#" + tabs[1] + "." + parentClass).addClass("active");
		$("#" + tabs[1] + "." + parentClass).removeClass("hidden");

		if (`${tabs[1]}` == "specials") {
			$(`#${tabs[1]}-selector`).removeClass("hidden");
		}
	}

	/* if ($(".swiper-tabs").length > 0) {
		const swiperTabs = new Swiper(".swiper-tabs", {
			loop: false,
			init: false,
			centeredSlides: true,
			roundLengths: true,
			slideToClickedSlide: true,
			spaceBetween: 15,
			slidesPerView: "auto",
		});

		if ($(window).width() < 1024) {
			//initSlick();
		}

		$(window).on("resize scroll", function () {
			if ($(window).width() < 1024) {
				//initSlick();
			} else {
				//destroySlick();
			}
		});

		function initSlick() {
			swiperTabs.init();
		}
		function destroySlick() {
			swiperTabs.destroy();
		}
	} */
});
